import Request from './request'

const Project  = {
  getProjects(params, callback) {
    Request.get('project/list', params).then(callback).catch(this.bad_answer)
  },
  getProjectInfo(project_id, callback) {
    Request.get('project/view/' + project_id).then(callback).catch(this.bad_answer)
  },
  updateProject(project_id, params, callback) {
    Request.post('project/update/' + project_id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  createProject(params, callback) {
    Request.post('project/create', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}

export default Project
